import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Typography, RadioGroup, Radio, FormControlLabel } from '@mui/material'
import { useSelector } from 'react-redux'

import documentWithPublicProfile from '../../../../resources/documents/condiciones_public.pdf'
import documentWithoutPublicProfile from '../../../../resources/documents/condiciones_other.pdf'
import { MandatoryCheckbox } from '../mandatory-checkbox'
import { useCompanyProfileContext } from '../../contexts'

export const CompanyPublicInput = ({ readOnly = false }) => {
  const { formatMessage } = useIntl()
  const { company, formState, changeFormState } = useCompanyProfileContext()
  const global = useSelector((state) => state.global)

  const defaultChecked =
    company.captadora && (!company.publica || !company.aux_pendiente_renovacion)
  const file = formState.publica === '01' ? documentWithPublicProfile : documentWithoutPublicProfile

  return (
    <>
      <Box mb={1}>
        <Typography variant="subtitle1" gutterBottom>
          {formatMessage({ id: 'pages.profile.company.publicProfileQuestion' })}
        </Typography>
        <RadioGroup
          name="publica"
          value={formState.publica}
          onChange={readOnly ? undefined : changeFormState}
          style={{
            width: 80,
            paddingLeft: 10,
            pointerEvents: readOnly ? 'none' : 'auto',
            opacity: readOnly ? 0.6 : 1,
          }}
        >
          <FormControlLabel
            value={'01'}
            control={<Radio size="small" color="primary" disabled={readOnly} />}
            label={
              <Typography variant="body1" color="textSecondary">
                {formatMessage({ id: 'global.true' })}
              </Typography>
            }
          />
          <FormControlLabel
            value={'00'}
            control={<Radio size="small" color="primary" disabled={readOnly} />}
            label={
              <Typography variant="body1" color="textSecondary">
                {formatMessage({ id: 'global.false' })}
              </Typography>
            }
          />
        </RadioGroup>
      </Box>
      {global.role !== 'administrador_prescriptor' && (
        <MandatoryCheckbox
          {...{ file, trigger: formState.publica, defaultChecked, disabled: readOnly }}
        />
      )}
    </>
  )
}
